
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as qruqKIAOjlysccYW9df1HYSTC9kzpUsLim_NDRTfbMs4gMeta } from "/opt/build/repo/iznik-nuxt3/pages/qr.vue?macro=true";
import { default as helpWOd3qdxgOp4I02lYXJ1MlmioEDtujTUb9_45OQZ6AOCQcMeta } from "/opt/build/repo/iznik-nuxt3/pages/help.vue?macro=true";
import { default as jobsoLUvsJZ3Gw9B7Hk93CzXq_TgoUQvSP0Q_UOoMbAE5AUMeta } from "/opt/build/repo/iznik-nuxt3/pages/jobs.vue?macro=true";
import { default as logs4g_45LKVHi2Vv9rhgDEYk3sTEmA7gIg2DmG9gJzeCcKxEMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/logs.vue?macro=true";
import { default as postk0rXsEXeUR1KScTwZt0rxd4iuDAu0k8jY10NM9BxVBgMeta } from "/opt/build/repo/iznik-nuxt3/pages/post.vue?macro=true";
import { default as aboutvJEStdkYWjIiRTfmwAtZI8ZmBIOrx1_2tCEAL8e4QBIMeta } from "/opt/build/repo/iznik-nuxt3/pages/about.vue?macro=true";
import { default as essexQUBaSLB6j57oYxoHUi8WOE3OHUoj2PEmY9zK4EckpfQMeta } from "/opt/build/repo/iznik-nuxt3/pages/essex.vue?macro=true";
import { default as index9qQberYSOqzhwNoBBjUVCrZkN2MTZYi_VkYS0wlW9boMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/index.vue?macro=true";
import { default as loginCmaU3raHK2gyH__3yojmfvym1yUdKI209GRKAHEcfEcMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/login.vue?macro=true";
import { default as merge6mK4TYJXNBBFoISCavJNBUHkIO_45Fy5T9xOidloKAyaMMeta } from "/opt/build/repo/iznik-nuxt3/pages/merge.vue?macro=true";
import { default as teamsjNu_45NpOt9_PvP_459KAEB_bm2GiFWpX0T6PuQ9XdgjeMEMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/teams.vue?macro=true";
import { default as termsmm6DTCswOBF0UXQpLdwsROLQz4FoYtRt7ViPSznLeqkMeta } from "/opt/build/repo/iznik-nuxt3/pages/terms.vue?macro=true";
import { default as admins3x6Zc_45rQ8KHHo3ktN7CofC4onznuT1OV6kqvv84lBa0Meta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/admins.vue?macro=true";
import { default as adsoffF_UdT54BXUaUn0wEBBaaUXbNO1pKKvIlLZAuQQBbxLIMeta } from "/opt/build/repo/iznik-nuxt3/pages/adsoff.vue?macro=true";
import { default as adtest3FVSArftffKau_DMKpPI0qkmGrciwsMGFJWKxpx5SkoMeta } from "/opt/build/repo/iznik-nuxt3/pages/adtest.vue?macro=true";
import { default as applogHUpCx6_45f5iY9rs2Cz4GU7PKGtPO4jtRob_45Vvz8Bae5UMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/applog.vue?macro=true";
import { default as donateceuwxHM4l2yf0ctgyAuDYmrEKG9PSnVTjirm8xSzqv8Meta } from "/opt/build/repo/iznik-nuxt3/pages/donate.vue?macro=true";
import { default as engagesifOcTRZe3n97EwAaCzWKkzc_45voCMVzBPWAXBubdXSwMeta } from "/opt/build/repo/iznik-nuxt3/pages/engage.vue?macro=true";
import { default as forgot6RNipLZkyFJ3MjFL7UuLIh5s0XYfCKEkQGQNVKDOE4wMeta } from "/opt/build/repo/iznik-nuxt3/pages/forgot.vue?macro=true";
import { default as mobileusy_lhnFZGUe5SVVKlrtkkWS9RexOTFVgix_cOu_45MrMMeta } from "/opt/build/repo/iznik-nuxt3/pages/mobile.vue?macro=true";
import { default as mydata4wh8EKwSSkIyI4SYpvxOuktpUWy6NlDGca_q3PS00fwMeta } from "/opt/build/repo/iznik-nuxt3/pages/mydata.vue?macro=true";
import { default as adtest2DUbWO0ggQODYGwTKOwLySpKKFCuGIwEgLL29LeQdInYMeta } from "/opt/build/repo/iznik-nuxt3/pages/adtest2.vue?macro=true";
import { default as donatedA8TGy9V4yKq9LlT2zm_zmtS_n09UvX_4DzJupPnKbqEMeta } from "/opt/build/repo/iznik-nuxt3/pages/donated.vue?macro=true";
import { default as giftaidvtWtcWfjqEy5JnWtKvaCLy8pPdE2HzXXRmb9S60px6AMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/giftaid.vue?macro=true";
import { default as mypostsn2jctXbrrAJD_45LSoEgaCst289h5BILE4ww7wR9fhvnMMeta } from "/opt/build/repo/iznik-nuxt3/pages/myposts.vue?macro=true";
import { default as privacy8aOxW0b5_45MBqMDqXvGeOUmA9xGKDs9BLpt9_45PCPLm28Meta } from "/opt/build/repo/iznik-nuxt3/pages/privacy.vue?macro=true";
import { default as promoteg65IObUZpE2Gy8IrqiUsJFts4m7dwdj_45g_45Wpob3IcIIMeta } from "/opt/build/repo/iznik-nuxt3/pages/promote.vue?macro=true";
import { default as _91id_93GuT7RI01hRgr_45EiuN9mRfGxBaL8VmDZQGhEz1lmuzMMMeta } from "/opt/build/repo/iznik-nuxt3/pages/job/[id].vue?macro=true";
import { default as ripplingN855IfUQXvhAt0xX_45jXxCA0u4hNIYUeFaW68TVn1eTsMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/rippling.vue?macro=true";
import { default as securitygn8jtAvneD5f_45wazPfM0rJm0EWFY98_45APGWT1YKjPXwMeta } from "/opt/build/repo/iznik-nuxt3/pages/security.vue?macro=true";
import { default as spammersxpti2YycuOntFTronlI_NJLNcEvF_45OdiRMyKNLKZjhoMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/spammers.vue?macro=true";
import { default as togetherlhy8JgIuGHdUsQgYdWSEh4izfz85fbHCTGC7BJaxIiwMeta } from "/opt/build/repo/iznik-nuxt3/pages/together.vue?macro=true";
import { default as discoursebA9SIKTREO_45afehNdDzMe_SSZ86Wr6XE859uC55BQo4Meta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/discourse.vue?macro=true";
import { default as disclaimer_NYd_45Gr6tzgzhq_45_459QFDNRAoUR9B6vUGSPM0FJfqilMMeta } from "/opt/build/repo/iznik-nuxt3/pages/disclaimer.vue?macro=true";
import { default as indexKgOPliC9VlTlS5Ff_45JA2Oq6caLsO5jCFn0tNJI5fDZkMeta } from "/opt/build/repo/iznik-nuxt3/pages/find/index.vue?macro=true";
import { default as indexEoLa1YZbD2PaonXOn5WYM3MxPc_45Y_rzfrvuqEpqr6zsMeta } from "/opt/build/repo/iznik-nuxt3/pages/give/index.vue?macro=true";
import { default as simulationa3_NEyE_450UurY2XpAZK6LYaCzRR9qJz5yUmzqiPj_4508Meta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/simulation.vue?macro=true";
import { default as _91id_93vxLQpxg4HVWjodthyj0gRX9C7in4jo7SeG4U8kseQ9AMeta } from "/opt/build/repo/iznik-nuxt3/pages/story/[id].vue?macro=true";
import { default as replyWwyFj_G2ThBAjE85_boU4IZFCN2MP7m1hS9TzXrz0voMeta } from "/opt/build/repo/iznik-nuxt3/pages/chats/reply.vue?macro=true";
import { default as whoamib2NOY5cxqwUHaDpoEXeykuUtqm62Q3caoZEU5JYyA_45IMeta } from "/opt/build/repo/iznik-nuxt3/pages/find/whoami.vue?macro=true";
import { default as whoamiHTwmTMedcv4PBr1kR6gRvxe2G6dZdLjBw2ROtiSh1E4Meta } from "/opt/build/repo/iznik-nuxt3/pages/give/whoami.vue?macro=true";
import { default as maintenanceEuLgaYXNX_45Qr7vtAtjDoGQ4THs9yArPBhP2RPmZmzgoMeta } from "/opt/build/repo/iznik-nuxt3/pages/maintenance.vue?macro=true";
import { default as _91_91id_93_93jDCAbppxQ6yV2hPXcI7Q4_45xzFs4IUIBUlVGnZNTC1OkMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/chats/[[id]].vue?macro=true";
import { default as reviewcqTT1OaAXTjlEaSL81LKdhItS_45g2t1o8ifNQQBHfZYIMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/chats/review.vue?macro=true";
import { default as optionsZ2JbSV6xQOkqxk_mD5cdPsifPIbK8z1UjuLIuJk6MP8Meta } from "/opt/build/repo/iznik-nuxt3/pages/give/options.vue?macro=true";
import { default as index37qjWvx8qkSphxGQlPOiUOnSp_457I4IOyAU8w1ZK2iH4Meta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/images/index.vue?macro=true";
import { default as _91id_93eLvisoxiiBagUIQmkxhqwrYDttJNP3wvVS82jOOygtUMeta } from "/opt/build/repo/iznik-nuxt3/pages/message/[id].vue?macro=true";
import { default as partnershipsN05NPjnyyPV841GVVircCFYNqC5IS6J1llfEhIXDYXYMeta } from "/opt/build/repo/iznik-nuxt3/pages/partnerships.vue?macro=true";
import { default as _91id_93CW8RgLAVSaaoR1f5uhefgqpm2EUJ2USLzLWs4ow0U9oMeta } from "/opt/build/repo/iznik-nuxt3/pages/profile/[id].vue?macro=true";
import { default as indexpRZAEZOFPY3aHCIlNbd1VptMV4EkJi87VeLCsKitzNEMeta } from "/opt/build/repo/iznik-nuxt3/pages/charity/index.vue?macro=true";
import { default as whereamiBEVZLNVfWtXFifjS85TW0HCQH_45yHajvt1N9e5npA_UIMeta } from "/opt/build/repo/iznik-nuxt3/pages/find/whereami.vue?macro=true";
import { default as whereamiJz66FHOresThoyqzSGM_45_45dRpRWfcEQSKeoatOISW2kYMeta } from "/opt/build/repo/iznik-nuxt3/pages/give/whereami.vue?macro=true";
import { default as heatmapgwRAiiudNOws_QmXkhhYQFnGQgNEEbLy_45URNTs8k6PIMeta } from "/opt/build/repo/iznik-nuxt3/pages/stats/heatmap.vue?macro=true";
import { default as _91id_93vqk0E6wK3VGtdaOWdu_KXmQJ8eDzUABUA0jkCJZVauIMeta } from "/opt/build/repo/iznik-nuxt3/pages/clearance/[id].vue?macro=true";
import { default as _91_91id_93_932VzvwC3Mram0d_C5hN1X9IbYQbmvxwUbKzfYcf1AQCQMeta } from "/opt/build/repo/iznik-nuxt3/pages/explore/[[id]].vue?macro=true";
import { default as clearanceENp5oletC34TxSOnmt_HVcl7_45ypK4SzSPPTZ2KBvimYMeta } from "/opt/build/repo/iznik-nuxt3/pages/give/clearance.vue?macro=true";
import { default as reviewCL1AAC7awU75QtU42PUGeOVa1aYNrojXTGFrxc_45ZTqsMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/members/review.vue?macro=true";
import { default as editsboDPSYOR8a4QjfZLBTW77c5jf_45VU_4515EWuqABSbalAAMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/messages/edits.vue?macro=true";
import { default as indexSmttuaRJiQkQ3f6pv6mVxBL_v0MGfePGn6q5qmFiNTAMeta } from "/opt/build/repo/iznik-nuxt3/pages/settings/index.vue?macro=true";
import { default as _91id_93Awn0nGyQ0y2O1OpgcudAl4o2jSqsOoStod0xDTZ3OacMeta } from "/opt/build/repo/iznik-nuxt3/pages/shortlink/[id].vue?macro=true";
import { default as _91_91id_93_93UoUlgRRHCsiuVo_DwqJk0PGzxMDv_45m1LjVNwf39znzwMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/support/[[id]].vue?macro=true";
import { default as index5CrCsD61JTdT_45e5Z06PazparHpqMTqQc2twp_45CvCwWwMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/sysadmin/index.vue?macro=true";
import { default as _91_91term_93_938tDtLV9oUuucyhrZ5AEZGdCELtJ52tzFM_45tH4LeIPOYMeta } from "/opt/build/repo/iznik-nuxt3/pages/browse/[[term]].vue?macro=true";
import { default as calendar_46cliente1vb_457A6XsGQWbvVeGXjutGeZ5Y_rDPRSH1RWrBEVwoMeta } from "/opt/build/repo/iznik-nuxt3/pages/calendar.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/opt/build/repo/iznik-nuxt3/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as _91_91id_93_934v_45_eoLpioGIBiOwtYbrS4hgES6GQIIuOvv6GqiY9XwMeta } from "/opt/build/repo/iznik-nuxt3/pages/chitchat/[[id]].vue?macro=true";
import { default as _91_91groupid_93_930AeXFqqDhgA7cz2buY4GmR1jcL6dOK108dvGq2HYP1kMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/map/[[groupid]].vue?macro=true";
import { default as relatedL_FFl50eJJldTyPq84narGjU0RRjDxF8_3jBU96j4ekMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/members/related.vue?macro=true";
import { default as stories48LM860oXa47U42AXmIUIXvEz1eSCCpfqmu8rU0_45ZJ4Meta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/members/stories.vue?macro=true";
import { default as _91_91id_93_93IqrksEqHABoRUzoPqVtEu5NeiOs55mSNXGe2jyEiGlAMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/settings/[[id]].vue?macro=true";
import { default as _91id_93rhREk4QVPWyHdqBdfxAJUj6HnSSTw2_GblF4_KjlHi4Meta } from "/opt/build/repo/iznik-nuxt3/pages/shortlinks/[id].vue?macro=true";
import { default as summaryF_Eil8igKgYX4Bzc1MKiYezoDLAcYCx2SNT67NCTFSUMeta } from "/opt/build/repo/iznik-nuxt3/pages/stories/summary.vue?macro=true";
import { default as helper_45escalatedNj5MyNnH85x7PreptjiV7uGHHXFXniyyJnhWCS_45WeqsMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/helper-escalated.vue?macro=true";
import { default as marketing_45optout7VHgunv1oESg0xJ6CRMi8BTiuEsAyBXefOs_45nwp8o9gMeta } from "/opt/build/repo/iznik-nuxt3/pages/marketing-optout.vue?macro=true";
import { default as feedback46dij7nTQu_45_UgNOFMgoSJri3EUtv5xGih6I_45fuLMl0Meta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/members/feedback.vue?macro=true";
import { default as NationalReuseDayHHbhQi902r0fu2zWgubZLlU3vf8hoOg6JR88q3m3WmkMeta } from "/opt/build/repo/iznik-nuxt3/pages/NationalReuseDay.vue?macro=true";
import { default as indexHtvuICEJuO9LaukQCir_454GPU0KGZp4o_oOREq6h0iYkMeta } from "/opt/build/repo/iznik-nuxt3/pages/shortlinks/index.vue?macro=true";
import { default as _91id_93u1IxbPW9d1vNKNdRVV4CrXqTx5x1N8_459fpUFE9z9G6QMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/alert/viewed/[id].vue?macro=true";
import { default as indexuFMhZNb5apIOcHjpeauNaNwAmmSlL3w731raP0AEia8Meta } from "/opt/build/repo/iznik-nuxt3/pages/find/mobile/index.vue?macro=true";
import { default as indexH_lrDYihNPJEsL9k_8tVq9SvUUsaKpOTxhSY7FI6WFsMeta } from "/opt/build/repo/iznik-nuxt3/pages/give/mobile/index.vue?macro=true";
import { default as authoritiesYW_45nk2k92_45yg3CgJVhvHKxNs9k7ay4GQwPfbg0lwn1kMeta } from "/opt/build/repo/iznik-nuxt3/pages/stats/authorities.vue?macro=true";
import { default as photos_45M6m1_s_ZV2B_4581bYvQtK11r5ulinIGrRSyCsXvDyRMMeta } from "/opt/build/repo/iznik-nuxt3/pages/find/mobile/photos.vue?macro=true";
import { default as photosyzaZ1rdSDdWpOq1Rt5sBbKcybdzWgxppRtNIOAWiYh4Meta } from "/opt/build/repo/iznik-nuxt3/pages/give/mobile/photos.vue?macro=true";
import { default as JustGivingThankYoulr_45vlQ5oRSAj6zFUZ8diAVRf0Q4jhYMrtRLqEjzJ648Meta } from "/opt/build/repo/iznik-nuxt3/pages/JustGivingThankYou.vue?macro=true";
import { default as newslettereFCHdbjTEyCtEvJcTqjFC2nlI3Fk241G1Y6GhF5PwFgMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/members/newsletter.vue?macro=true";
import { default as _91_46_46_46slug_93xkHUpf2UEKNkXD3B5dCeSUjCohSXMa9WNbOF0SDoO28Meta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/modtools/[...slug].vue?macro=true";
import { default as _91_91id_93_938m5Gh8_PGTDlXc9kgAFTyMGjN6goB2ptkcbQo7qUnAsMeta } from "/opt/build/repo/iznik-nuxt3/pages/unsubscribe/[[id]].vue?macro=true";
import { default as _91_91id_93_93phg2_45J8zUTjz_45DMnw2_d6C4eKsPF3k0OmM8LJMA_45UPcMeta } from "/opt/build/repo/iznik-nuxt3/pages/explore/join/[[id]].vue?macro=true";
import { default as detailsdc_EdyIdNbqdfyqhG9ZZRg_XzfMSJ5D9pKkbdLDCJw4Meta } from "/opt/build/repo/iznik-nuxt3/pages/find/mobile/details.vue?macro=true";
import { default as detailsUG0L0jRWwClUmEjoKiyWE0HTxOebxVR7Oj389v5p6mcMeta } from "/opt/build/repo/iznik-nuxt3/pages/give/mobile/details.vue?macro=true";
import { default as options_dTYqnPM4v688mMQK8tnAtvk4kNy_45T04dnJckPs8PAUMeta } from "/opt/build/repo/iznik-nuxt3/pages/give/mobile/options.vue?macro=true";
import { default as _91_91id_93_93ecCqcT5wDald3sk84w_45_FeMohGm56mg9m8vdqZIzZNsMeta } from "/opt/build/repo/iznik-nuxt3/pages/noticeboards/[[id]].vue?macro=true";
import { default as _91_91groupname_93_939TjsePzMxRUQn2cGb6CEvZMKqH7cKnP5AEUxAbhpQNEMeta } from "/opt/build/repo/iznik-nuxt3/pages/stats/[[groupname]].vue?macro=true";
import { default as _91_91groupid_93_93VrIl7AZdRK0E7RY_2FEU5ZYT4jGuQvJLSlGlGGeNo5gMeta } from "/opt/build/repo/iznik-nuxt3/pages/stories/[[groupid]].vue?macro=true";
import { default as _91_91id_93_93g7VC_45GRXLPa9X098Z7rxfuqkbXmqTWjyrN17dwyBAYgMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/volunteering/[[id]].vue?macro=true";
import { default as whereamiAlYTU8B7_5RlX2g8E4_45I2iq7csz_eB_8zNburYAi7eUMeta } from "/opt/build/repo/iznik-nuxt3/pages/find/mobile/whereami.vue?macro=true";
import { default as whereamiV_45FUWPbTcWoe2sbev1MNU_FxnIpfl_Qwshvo2GuhOpMMeta } from "/opt/build/repo/iznik-nuxt3/pages/give/mobile/whereami.vue?macro=true";
import { default as _91_91id_93_93Crpqf_3O7B13QJ7VIl9ku_45I_7oiTRjlVu_45mh9KFx7u4Meta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/members/notes/[[id]].vue?macro=true";
import { default as helper_45flowq7cX56CG_45aZRBZRQCpXijJIQCGPm5C2i_45NYZ_455HiqsIMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/modtools/helper-flow.vue?macro=true";
import { default as _91_91id_93_93PkEzFS_45TI2qX7jYuzY1LD8pj_45vIYoRE4pL1RJ7LeOm4Meta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/support/refer/[[id]].vue?macro=true";
import { default as _91_91id_93_93SmUMq5N_aJ3agR0Kr7iElc2RIIFiL_45TDRTwiXhLAtJIMeta } from "/opt/build/repo/iznik-nuxt3/pages/communityevent/[[id]].vue?macro=true";
import { default as _91place_93nH_xyLwOg_45tM5iQ22VuY3yrQmK38eKzT1CZYygVrJwYMeta } from "/opt/build/repo/iznik-nuxt3/pages/explore/place/[place].vue?macro=true";
import { default as _91_91groupname_93_93RLwsatoq3PgADwetDEFLSU9QDbYEeCDkJDwgVVOkIcsMeta } from "/opt/build/repo/iznik-nuxt3/pages/birthday/[[groupname]].vue?macro=true";
import { default as _91_91action_93_93E_45UAaGoeQh_uqPoe0i0LqwUfy2lx4_45cyUYZ0wxc6ICsMeta } from "/opt/build/repo/iznik-nuxt3/pages/mypost/[id]/[[action]].vue?macro=true";
import { default as _91_91id_93_93BVn6I6O7mqjHseiUa3aXlteiqpUcZpHcMyr45R7SWL8Meta } from "/opt/build/repo/iznik-nuxt3/pages/stats/authority/[[id]].vue?macro=true";
import { default as _91id_93Sn_45ZlZgpDH20jJBum9_450zlV1L5KEMPJfKX654E0mm9cMeta } from "/opt/build/repo/iznik-nuxt3/pages/stories/authority/[id].vue?macro=true";
import { default as _91region_93X_1RqbsM1XT7C1FCYDoyVQQSCrHMLcRIUOwQlupKlw8Meta } from "/opt/build/repo/iznik-nuxt3/pages/explore/region/[region].vue?macro=true";
import { default as _91token_933BXoEiFaQ00EqmR9UHvpXH2wIQ3cRAjSGExx1Q1naugMeta } from "/opt/build/repo/iznik-nuxt3/pages/clearance/update/[token].vue?macro=true";
import { default as unsubscribeddSqJsjEf5GGadFRmHoxBgVK4cWM6Kk6pxoG_45fBUFTZoMeta } from "/opt/build/repo/iznik-nuxt3/pages/unsubscribe/unsubscribed.vue?macro=true";
import { default as _91_91groupid_93_93xZLHIohcwlg3l5NSA22ioqxQrTZJdL5pzntEu7VVrdgMeta } from "/opt/build/repo/iznik-nuxt3/pages/volunteerings/[[groupid]].vue?macro=true";
import { default as _91key_93seNtr_45LwDODoEFZcB5tv6g6FhnKXg0ar5KxyEF5rlloMeta } from "/opt/build/repo/iznik-nuxt3/pages/settings/confirmmail/[key].vue?macro=true";
import { default as _91_91groupid_93_93bBcK544rbL6z481SIBlVwl1NipFfLahhsU2OTIOCLXUMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/communityevents/[[groupid]].vue?macro=true";
import { default as _91_91msgid_93_93SSus3nyf3JDs70DqK4u2De201MxZwyZ4cK3YkFCqpm0Meta } from "/opt/build/repo/iznik-nuxt3/pages/explore/[groupid]/[[msgid]].vue?macro=true";
import { default as _91_91id_93_93ThWSxuwZAcwYRaUKAfpGtqIQ6d3gZ15cUC_459HDj7XzkMeta } from "/opt/build/repo/iznik-nuxt3/pages/facebook/unsubscribe/[[id]].vue?macro=true";
import { default as _91_91groupname_93_93pZrs1HTcYpxVN7j5_45uK9Dn_v0cRShRzgscer_PRNPu8Meta } from "/opt/build/repo/iznik-nuxt3/pages/birthday/donate/[[groupname]].vue?macro=true";
import { default as _91_91id_93_93sBgiQKsGw3ORGUt3H8ewF_45JQZMz8_45clxAKJzT9OasTYMeta } from "/opt/build/repo/iznik-nuxt3/pages/noticeboards/authority/[[id]].vue?macro=true";
import { default as index_46client9p7HGLxWapVjdmZTqDieAsss_0tFfbYhOOxgVEHYGkIMeta } from "/opt/build/repo/iznik-nuxt3/pages/microvolunteering/index.client.vue?macro=true";
import { default as _91_91term_93_93icU9j1mqHTnEzX_DrzAjwyA7HpLvFfzHPqy_457RxnNMwMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/members/approved/[[id]]/[[term]].vue?macro=true";
import { default as _91_91id_93_93IXO_45fxHP23qaVcQNVSh1_45uuPBI_45YBYv_4514KeF0lRGa0Meta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/members/microvolunteering/[[id]].vue?macro=true";
import { default as _91_91term_93_93m2yns_45ruMl9EPb4yU7oyPYLfrWuhiMRrnpdLLylLdqMMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/messages/pending/[[id]]/[[term]].vue?macro=true";
import { default as _91_91term_93_9304_9AmgojgOQ3i_45gkxa66HnH3hgROMKmNavno_45PNAXsMeta } from "/opt/build/repo/iznik-nuxt3/modtools/pages/messages/approved/[[id]]/[[term]].vue?macro=true";
import { default as _91_91key_93_93XZoG0s1SCEIzIm32LQBOSELx5Un8qWnqpv92xfhjhjsMeta } from "/opt/build/repo/iznik-nuxt3/pages/one-click-unsubscribe/[[uid]]/[[key]].vue?macro=true";
import { default as _91_91id_93_93_46clientiJekRtzKKzqxSSEXh4nEGQlBoONEARn_45umkrPZeahegMeta } from "/opt/build/repo/iznik-nuxt3/pages/microvolunteering/message/[[id]].client.vue?macro=true";
import { default as component_45stubyIyr4iBB25Z3BZUqSRMDWliOtg966MxIOOh34MBPeu0Meta } from "/opt/build/repo/iznik-nuxt3/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubyIyr4iBB25Z3BZUqSRMDWliOtg966MxIOOh34MBPeu0 } from "/opt/build/repo/iznik-nuxt3/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "qr",
    path: "/qr",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/qr.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/help.vue")
  },
  {
    name: "jobs",
    path: "/jobs",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/jobs.vue")
  },
  {
    name: "logs",
    path: "/logs",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/logs.vue")
  },
  {
    name: "post",
    path: "/post",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/post.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/about.vue")
  },
  {
    name: "essex",
    path: "/essex",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/essex.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/login.vue")
  },
  {
    name: "merge",
    path: "/merge",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/merge.vue")
  },
  {
    name: "teams",
    path: "/teams",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/teams.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/terms.vue")
  },
  {
    name: "admins",
    path: "/admins",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/admins.vue")
  },
  {
    name: "adsoff",
    path: "/adsoff",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/adsoff.vue")
  },
  {
    name: "adtest",
    path: "/adtest",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/adtest.vue")
  },
  {
    name: "applog",
    path: "/applog",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/applog.vue")
  },
  {
    name: "donate",
    path: "/donate",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/donate.vue")
  },
  {
    name: "engage",
    path: "/engage",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/engage.vue")
  },
  {
    name: "forgot",
    path: "/forgot",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/forgot.vue")
  },
  {
    name: "mobile",
    path: "/mobile",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/mobile.vue")
  },
  {
    name: "mydata",
    path: "/mydata",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/mydata.vue")
  },
  {
    name: "adtest2",
    path: "/adtest2",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/adtest2.vue")
  },
  {
    name: "donated",
    path: "/donated",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/donated.vue")
  },
  {
    name: "giftaid",
    path: "/giftaid",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/giftaid.vue")
  },
  {
    name: "myposts",
    path: "/myposts",
    meta: mypostsn2jctXbrrAJD_45LSoEgaCst289h5BILE4ww7wR9fhvnMMeta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/myposts.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/privacy.vue")
  },
  {
    name: "promote",
    path: "/promote",
    meta: promoteg65IObUZpE2Gy8IrqiUsJFts4m7dwdj_45g_45Wpob3IcIIMeta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/promote.vue")
  },
  {
    name: "job-id",
    path: "/job/:id()",
    meta: _91id_93GuT7RI01hRgr_45EiuN9mRfGxBaL8VmDZQGhEz1lmuzMMMeta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/job/[id].vue")
  },
  {
    name: "rippling",
    path: "/rippling",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/rippling.vue")
  },
  {
    name: "security",
    path: "/security",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/security.vue")
  },
  {
    name: "spammers",
    path: "/spammers",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/spammers.vue")
  },
  {
    name: "together",
    path: "/together",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/together.vue")
  },
  {
    name: "discourse",
    path: "/discourse",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/discourse.vue")
  },
  {
    name: "disclaimer",
    path: "/disclaimer",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/disclaimer.vue")
  },
  {
    name: "find",
    path: "/find",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/find/index.vue")
  },
  {
    name: "give",
    path: "/give",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/give/index.vue")
  },
  {
    name: "simulation",
    path: "/simulation",
    meta: simulationa3_NEyE_450UurY2XpAZK6LYaCzRR9qJz5yUmzqiPj_4508Meta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/simulation.vue")
  },
  {
    name: "story-id",
    path: "/story/:id()",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/story/[id].vue")
  },
  {
    name: "chats-reply",
    path: "/chats/reply",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/chats/reply.vue")
  },
  {
    name: "find-whoami",
    path: "/find/whoami",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/find/whoami.vue")
  },
  {
    name: "give-whoami",
    path: "/give/whoami",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/give/whoami.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/maintenance.vue")
  },
  {
    name: "chats-id",
    path: "/chats/:id?",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/chats/[[id]].vue")
  },
  {
    name: "chats-review",
    path: "/chats/review",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/chats/review.vue")
  },
  {
    name: "give-options",
    path: "/give/options",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/give/options.vue")
  },
  {
    name: "images",
    path: "/images",
    meta: index37qjWvx8qkSphxGQlPOiUOnSp_457I4IOyAU8w1ZK2iH4Meta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/images/index.vue")
  },
  {
    name: "message-id",
    path: "/message/:id()",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/message/[id].vue")
  },
  {
    name: "partnerships",
    path: "/partnerships",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/partnerships.vue")
  },
  {
    name: "profile-id",
    path: "/profile/:id()",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/profile/[id].vue")
  },
  {
    name: "charity",
    path: "/charity",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/charity/index.vue")
  },
  {
    name: "find-whereami",
    path: "/find/whereami",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/find/whereami.vue")
  },
  {
    name: "give-whereami",
    path: "/give/whereami",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/give/whereami.vue")
  },
  {
    name: "stats-heatmap",
    path: "/stats/heatmap",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/stats/heatmap.vue")
  },
  {
    name: "clearance-id",
    path: "/clearance/:id()",
    meta: _91id_93vqk0E6wK3VGtdaOWdu_KXmQJ8eDzUABUA0jkCJZVauIMeta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/clearance/[id].vue")
  },
  {
    name: "explore-id",
    path: "/explore/:id?",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/explore/[[id]].vue")
  },
  {
    name: "give-clearance",
    path: "/give/clearance",
    meta: clearanceENp5oletC34TxSOnmt_HVcl7_45ypK4SzSPPTZ2KBvimYMeta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/give/clearance.vue")
  },
  {
    name: "members-review",
    path: "/members/review",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/members/review.vue")
  },
  {
    name: "messages-edits",
    path: "/messages/edits",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/messages/edits.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: indexSmttuaRJiQkQ3f6pv6mVxBL_v0MGfePGn6q5qmFiNTAMeta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/settings/index.vue")
  },
  {
    name: "shortlink-id",
    path: "/shortlink/:id()",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/shortlink/[id].vue")
  },
  {
    name: "support-id",
    path: "/support/:id?",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/support/[[id]].vue")
  },
  {
    name: "sysadmin",
    path: "/sysadmin",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/sysadmin/index.vue")
  },
  {
    name: "browse-term",
    path: "/browse/:term?",
    meta: _91_91term_93_938tDtLV9oUuucyhrZ5AEZGdCELtJ52tzFM_45tH4LeIPOYMeta || {},
    alias: ["/communities"],
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/browse/[[term]].vue")
  },
  {
    name: "calendar",
    path: "/calendar",
    component: () => createClientPage(() => import("/opt/build/repo/iznik-nuxt3/pages/calendar.client.vue"))
  },
  {
    name: "chitchat-id",
    path: "/chitchat/:id?",
    meta: _91_91id_93_934v_45_eoLpioGIBiOwtYbrS4hgES6GQIIuOvv6GqiY9XwMeta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/chitchat/[[id]].vue")
  },
  {
    name: "map-groupid",
    path: "/map/:groupid?",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/map/[[groupid]].vue")
  },
  {
    name: "members-related",
    path: "/members/related",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/members/related.vue")
  },
  {
    name: "members-stories",
    path: "/members/stories",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/members/stories.vue")
  },
  {
    name: "settings-id",
    path: "/settings/:id?",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/settings/[[id]].vue")
  },
  {
    name: "shortlinks-id",
    path: "/shortlinks/:id()",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/shortlinks/[id].vue")
  },
  {
    name: "stories-summary",
    path: "/stories/summary",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/stories/summary.vue")
  },
  {
    name: "helper-escalated",
    path: "/helper-escalated",
    meta: helper_45escalatedNj5MyNnH85x7PreptjiV7uGHHXFXniyyJnhWCS_45WeqsMeta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/helper-escalated.vue")
  },
  {
    name: "marketing-optout",
    path: "/marketing-optout",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/marketing-optout.vue")
  },
  {
    name: "members-feedback",
    path: "/members/feedback",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/members/feedback.vue")
  },
  {
    name: "NationalReuseDay",
    path: "/NationalReuseDay",
    meta: NationalReuseDayHHbhQi902r0fu2zWgubZLlU3vf8hoOg6JR88q3m3WmkMeta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/NationalReuseDay.vue")
  },
  {
    name: "shortlinks",
    path: "/shortlinks",
    meta: indexHtvuICEJuO9LaukQCir_454GPU0KGZp4o_oOREq6h0iYkMeta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/shortlinks/index.vue")
  },
  {
    name: "alert-viewed-id",
    path: "/alert/viewed/:id()",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/alert/viewed/[id].vue")
  },
  {
    name: "find-mobile",
    path: "/find/mobile",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/find/mobile/index.vue")
  },
  {
    name: "give-mobile",
    path: "/give/mobile",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/give/mobile/index.vue")
  },
  {
    name: "stats-authorities",
    path: "/stats/authorities",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/stats/authorities.vue")
  },
  {
    name: "find-mobile-photos",
    path: "/find/mobile/photos",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/find/mobile/photos.vue")
  },
  {
    name: "give-mobile-photos",
    path: "/give/mobile/photos",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/give/mobile/photos.vue")
  },
  {
    name: "JustGivingThankYou",
    path: "/JustGivingThankYou",
    meta: JustGivingThankYoulr_45vlQ5oRSAj6zFUZ8diAVRf0Q4jhYMrtRLqEjzJ648Meta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/JustGivingThankYou.vue")
  },
  {
    name: "members-newsletter",
    path: "/members/newsletter",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/members/newsletter.vue")
  },
  {
    name: "modtools-slug",
    path: "/modtools/:slug(.*)*",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/modtools/[...slug].vue")
  },
  {
    name: "unsubscribe-id",
    path: "/unsubscribe/:id?",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/unsubscribe/[[id]].vue")
  },
  {
    name: "explore-join-id",
    path: "/explore/join/:id?",
    meta: _91_91id_93_93phg2_45J8zUTjz_45DMnw2_d6C4eKsPF3k0OmM8LJMA_45UPcMeta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/explore/join/[[id]].vue")
  },
  {
    name: "find-mobile-details",
    path: "/find/mobile/details",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/find/mobile/details.vue")
  },
  {
    name: "give-mobile-details",
    path: "/give/mobile/details",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/give/mobile/details.vue")
  },
  {
    name: "give-mobile-options",
    path: "/give/mobile/options",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/give/mobile/options.vue")
  },
  {
    name: "noticeboards-id",
    path: "/noticeboards/:id?",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/noticeboards/[[id]].vue")
  },
  {
    name: "stats-groupname",
    path: "/stats/:groupname?",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/stats/[[groupname]].vue")
  },
  {
    name: "stories-groupid",
    path: "/stories/:groupid?",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/stories/[[groupid]].vue")
  },
  {
    name: "volunteering-id",
    path: "/volunteering/:id?",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/volunteering/[[id]].vue")
  },
  {
    name: "find-mobile-whereami",
    path: "/find/mobile/whereami",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/find/mobile/whereami.vue")
  },
  {
    name: "give-mobile-whereami",
    path: "/give/mobile/whereami",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/give/mobile/whereami.vue")
  },
  {
    name: "members-notes-id",
    path: "/members/notes/:id?",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/members/notes/[[id]].vue")
  },
  {
    name: "modtools-helper-flow",
    path: "/modtools/helper-flow",
    meta: helper_45flowq7cX56CG_45aZRBZRQCpXijJIQCGPm5C2i_45NYZ_455HiqsIMeta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/modtools/helper-flow.vue")
  },
  {
    name: "support-refer-id",
    path: "/support/refer/:id?",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/support/refer/[[id]].vue")
  },
  {
    name: "communityevent-id",
    path: "/communityevent/:id?",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/communityevent/[[id]].vue")
  },
  {
    name: "explore-place-place",
    path: "/explore/place/:place()",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/explore/place/[place].vue")
  },
  {
    name: "birthday-groupname",
    path: "/birthday/:groupname?",
    meta: _91_91groupname_93_93RLwsatoq3PgADwetDEFLSU9QDbYEeCDkJDwgVVOkIcsMeta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/birthday/[[groupname]].vue")
  },
  {
    name: "mypost-id-action",
    path: "/mypost/:id()/:action?",
    meta: _91_91action_93_93E_45UAaGoeQh_uqPoe0i0LqwUfy2lx4_45cyUYZ0wxc6ICsMeta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/mypost/[id]/[[action]].vue")
  },
  {
    name: "stats-authority-id",
    path: "/stats/authority/:id?",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/stats/authority/[[id]].vue")
  },
  {
    name: "stories-authority-id",
    path: "/stories/authority/:id()",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/stories/authority/[id].vue")
  },
  {
    name: "explore-region-region",
    path: "/explore/region/:region()",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/explore/region/[region].vue")
  },
  {
    name: "clearance-update-token",
    path: "/clearance/update/:token()",
    meta: _91token_933BXoEiFaQ00EqmR9UHvpXH2wIQ3cRAjSGExx1Q1naugMeta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/clearance/update/[token].vue")
  },
  {
    name: "unsubscribe-unsubscribed",
    path: "/unsubscribe/unsubscribed",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/unsubscribe/unsubscribed.vue")
  },
  {
    name: "volunteerings-groupid",
    path: "/volunteerings/:groupid?",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/volunteerings/[[groupid]].vue")
  },
  {
    name: "settings-confirmmail-key",
    path: "/settings/confirmmail/:key()",
    meta: _91key_93seNtr_45LwDODoEFZcB5tv6g6FhnKXg0ar5KxyEF5rlloMeta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/settings/confirmmail/[key].vue")
  },
  {
    name: "communityevents-groupid",
    path: "/communityevents/:groupid?",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/communityevents/[[groupid]].vue")
  },
  {
    name: "explore-groupid-msgid",
    path: "/explore/:groupid()/:msgid?",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/explore/[groupid]/[[msgid]].vue")
  },
  {
    name: "facebook-unsubscribe-id",
    path: "/facebook/unsubscribe/:id?",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/facebook/unsubscribe/[[id]].vue")
  },
  {
    name: "birthday-donate-groupname",
    path: "/birthday/donate/:groupname?",
    meta: _91_91groupname_93_93pZrs1HTcYpxVN7j5_45uK9Dn_v0cRShRzgscer_PRNPu8Meta || {},
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/birthday/donate/[[groupname]].vue")
  },
  {
    name: "noticeboards-authority-id",
    path: "/noticeboards/authority/:id?",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/noticeboards/authority/[[id]].vue")
  },
  {
    name: "microvolunteering",
    path: "/microvolunteering",
    meta: index_46client9p7HGLxWapVjdmZTqDieAsss_0tFfbYhOOxgVEHYGkIMeta || {},
    component: () => createClientPage(() => import("/opt/build/repo/iznik-nuxt3/pages/microvolunteering/index.client.vue"))
  },
  {
    name: "members-approved-id-term",
    path: "/members/approved/:id?/:term?",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/members/approved/[[id]]/[[term]].vue")
  },
  {
    name: "members-microvolunteering-id",
    path: "/members/microvolunteering/:id?",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/members/microvolunteering/[[id]].vue")
  },
  {
    name: "messages-pending-id-term",
    path: "/messages/pending/:id?/:term?",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/messages/pending/[[id]]/[[term]].vue")
  },
  {
    name: "messages-approved-id-term",
    path: "/messages/approved/:id?/:term?",
    component: () => import("/opt/build/repo/iznik-nuxt3/modtools/pages/messages/approved/[[id]]/[[term]].vue")
  },
  {
    name: "one-click-unsubscribe-uid-key",
    path: "/one-click-unsubscribe/:uid?/:key?",
    component: () => import("/opt/build/repo/iznik-nuxt3/pages/one-click-unsubscribe/[[uid]]/[[key]].vue")
  },
  {
    name: "microvolunteering-message-id",
    path: "/microvolunteering/message/:id?",
    meta: _91_91id_93_93_46clientiJekRtzKKzqxSSEXh4nEGQlBoONEARn_45umkrPZeahegMeta || {},
    component: () => createClientPage(() => import("/opt/build/repo/iznik-nuxt3/pages/microvolunteering/message/[[id]].client.vue"))
  },
  {
    name: component_45stubyIyr4iBB25Z3BZUqSRMDWliOtg966MxIOOh34MBPeu0Meta?.name,
    path: "/councils",
    component: component_45stubyIyr4iBB25Z3BZUqSRMDWliOtg966MxIOOh34MBPeu0
  }
]